import script from "./CookieDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CookieDialog.vue?vue&type=script&setup=true&lang=js"

import "./CookieDialog.vue?vue&type=style&index=0&id=ffbd84fc&lang=scss"

const __exports__ = script;

export default __exports__